export default import.meta.ROLLDOWN_FILE_URL_31WasFqwQ8l0hCAsPLLhsA